import React, { useEffect, useState } from 'react'
import millify from 'millify'
import { Link } from 'react-router-dom'
import { Card, Row, Col ,Input } from 'antd'

import { useGetCryptosQuery } from '../services/cryptoApi'

function Cryptocurrencies({simplified}) {

  const count = simplified? 10 : 100;
  const{data, isFetching} = useGetCryptosQuery(count);
  const[cryptos, setCrytpos] =  useState([]);
  const[searchTerm, setSearchTerm] = useState('')

  useEffect(() => {

      const filteredData = data?.data?.coins.filter((coin) => 
        coin.name.toLowerCase().includes(searchTerm.toLowerCase())); 
      
      setCrytpos(filteredData)  

      }, [data, searchTerm])

      if(isFetching) return 'Loading...'

  return (
    <>

    {!simplified && (
      <div className='search-crypto'>
        <Input placeholder='"Search Cryptocurrency' onChange={(e) => setSearchTerm(e.target.value)}></Input>
      </ div>
    )}
     
      <Row gutter={[32, 32]} className='crypto-card-container'>
        {cryptos?.map((currency) => (
            <Col xs={24} sm={12} lg={6} className="crypto-card" key={currency.uuid}>
                 <Link key={currency.uuid} to={`/crypto/${currency.uuid}`}>
                  <Card title={`${currency.rank}. ${currency.name}`}
                    extra={<img className='crypto-image' src={currency.iconUrl}/>}
                    hoverable
                  >
                    <p>Price: {millify(currency.price)}</p>
                    <p>Market Cap: {millify(currency.marketCap)}</p>
                    <p>Daily Change: {millify(currency.change)}%</p>
                  </Card>
                </Link>
            </Col>
        ))}
      </Row>
    </>
  )
}

export default Cryptocurrencies